import React, { useEffect } from "react";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { useLocation } from "react-router-dom";
import abbdox from "../../assets/images/other-pages/AbbaDox-logo.png";

const ForClinics = () => {
  const { hash } = useLocation();

  useEffect(() => {
    // Function to attempt scrolling to the target element
    const scrollToHash = () => {
      if (hash) {
        const targetId = hash.replace("#", "");
        const element = document.getElementById(targetId);
        if (element) {
          // Calculate navbar height (adjust based on your navbar's actual height)
          const navbarHeight = 180; // Adjust this value as needed
          const elementPosition =
            element.getBoundingClientRect().top + window.pageYOffset;
          window.scrollTo({
            top: elementPosition - navbarHeight,
            behavior: "smooth",
          });
        } else {
          console.warn(`Element with ID ${targetId} not found`);
          // Scroll to top if hash is invalid
          window.scrollTo({ top: 0, behavior: "smooth" });
        }
      } else {
        // Scroll to top if no hash
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    };

    // Initial attempt
    scrollToHash();

    // Retry after a short delay to account for AOS or DOM rendering
    const timer = setTimeout(scrollToHash, 500);

    // Cleanup timer on unmount
    return () => clearTimeout(timer);
  }, [hash]);

  return (
    <>
      <title>
        Clinician Resources | Citrus Diagnostic Center Crystal River
      </title>

      <meta
        name="description"
        content="Citrus Diagnostic Center empowers healthcare providers with secure imaging portals, simplified referrals and accurate diagnostics for enhanced patient outcomes."
      />
      <div className=" text-white flex justify-center items-center flex-col">
        {/* Rest of your JSX remains unchanged */}
        <div className="px-4 pb-8 sm:px-6  md:px-8  lg:px-10 flex 2xl:w-3/4 xl:w-4/5 w-11/12 slider-wrapper overflow-hidden justify-center relative items-center flex-col lg:pt-16">
          <div className="text-center mt-32 md:mt-16 lg:my-8">
            <h1
              data-aos="fade-up"
              className="text-white font-robout font-black text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-[10.25rem] capitalize tracking-[-.04em] leading-tight"
            >
              For Clinicians
            </h1>
            <div
              data-aos="fade-up"
              data-aso-delay="100"
              className="md:text-[1.7rem] text-2xl md:leading-10 tracking-tight text-white pt-6 sm:pt-8 md:pt-10 lg:pt-12 xl:pt-[4.75rem] font-robout"
            >
              <p>
                Welcome to the{" "}
                <span className="text-[#d78558]">
                  Citrus Diagnostic Center,
                </span>{" "}
                where our clinicians &nbsp;play an important role through their
                dedication towards making , with continuous investment in{" "}
                <span className="text-[#d78558]"> our patients</span>
                <span className="text-[#d78558]"> experience easy</span> ,
                <span className="text-[#d78558]"> comfortable</span> and
                <span className="text-[#d78558]"> effective</span>.
                <br />
                <br />
              </p>
            </div>
          </div>
          <div className="w-full font-robout">
            <ul className="w-full">
              
              <li
                data-aos="fade-up"
                data-aso-delay="300"
                className="grid lg:grid-cols-2 grid-cols-1 py-10 border-b-[1px] border-[#fafaf6] border-opacity-40"
                id="form"
              >
                <div>
                  <p className="text-[#d78558] sm:text-4xl text-[1.7rem] lg:mb-0 mb-4 font-black">
                    Physician Order Form
                  </p>
                </div>
                <div>
                  <p className="font-robout xl:text-[1.35rem] md:text-xl sm:text-lg text-[16px] text-[#fafaf6] pb-2">
                    Our physicians can get their patients’ diagnostic results
                    online at their convenience.
                  </p>
                  <p className="font-robout xl:text-[1.35rem] md:text-xl sm:text-lg text-[16px] text-[#fafaf6] pb-2">
                    It also helps the patients to choose the particular test
                    according to their choice.
                  </p>
                  <p className="font-robout xl:text-[1.35rem] md:text-xl sm:text-lg text-[16px] text-[#fafaf6]">
                    We ensure that every test result are accurate and precise.
                  </p>
                  <div className="flex sm:flex-row flex-col-reverse lg:flex-col-reverse xl:flex-row gap-3 md:items-center lg:items-start xl:items-center pt-2">
                    <button
                      aria-label="Physician Order Form"
                      onClick={() => window.open("./patientForm.pdf", "_blank")}
                      title="Patient Clinic Form"
                      className="group relative inline-flex h-14 mt-3 w-[256px] items-center rounded-full px-8 font-semibold text-white bg-transparent overflow-hidden"
                    >
                      <span className="absolute inset-0 rounded-full bg-[#d78558] transition-transform duration-[1800ms] ease-[cubic-bezier(0.19,1,0.22,1)] scale-100 group-hover:scale-100">
                        <span className="absolute left-1/2 top-[-60%] -translate-x-1/2 aspect-square w-[max(200%,10rem)]">
                          <span className="absolute inset-0 rounded-full bg-[#a374ff] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                          <span className="absolute inset-0 rounded-full bg-[#17f1d1] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-100 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                          <span className="absolute inset-0 rounded-full bg-[#d78558] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-200 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                        </span>
                      </span>
                      <span className="relative">
                        <span className="block group-hover:opacity-0 group-hover:-translate-y-[70%] transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                          Physician Order Form
                        </span>
                        <span className="absolute flex flex-row gap-2 top-0 left-10 opacity-0 translate-y-[70%] text-center group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                          <CloudDownloadIcon /> Download
                        </span>
                      </span>
                    </button>
                  </div>
                </div>
              </li>
              <li
                data-aos="fade-up"
                data-aso-delay="500"
                className="grid lg:grid-cols-2 grid-cols-1 py-10 mb-8 border-opacity-40"
                id="resources"
              >
                <div>
                  <p className="text-[#d78558] sm:text-4xl text-[1.7rem] lg:mb-0 mb-4 font-black">
                    Resources for Clinicians
                  </p>
                </div>
                <div>
                  <p className="font-robout xl:text-[1.35rem] md:text-xl sm:text-lg text-[16px] text-[#fafaf6] pb-2">
                    Our updated resources will help clinicians to make informed
                    decisions for the patient’s condition by guiding them
                    through proper guidelines and advanced tests, as we
                    continuously invest in a research program to maintain the
                    best care possible.
                  </p>
                  <div className="flex flex-row gap-3 items-center pt-2">
                    <a
                      target="_blank"
                      href="https://www.acr.org/Clinical-Resources/Clinical-Tools-and-Reference/Appropriateness-Criteria"
                      rel="noreferrer noopener"
                    >
                      <button
                        aria-label="Get the Resources"
                        className="group relative inline-flex h-14 mt-3 w-full lg:w-[256px] items-center rounded-full px-8 font-semibold text-white bg-transparent overflow-hidden"
                      >
                        <span className="absolute inset-0 rounded-full bg-[#d78558] transition-transform duration-[1800ms] ease-[cubic-bezier(0.19,1,0.22,1)] scale-100 group-hover:scale-100">
                          <span className="absolute left-1/2 top-[-60%] -translate-x-1/2 aspect-square w-[max(200%,10rem)]">
                            <span className="absolute inset-0 rounded-full bg-[#a374ff] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                            <span className="absolute inset-0 rounded-full bg-[#17f1d1] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-100 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                            <span className="absolute inset-0 rounded-full bg-[#d78558] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-200 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                          </span>
                        </span>
                        <span className="relative">
                          <span className="block group-hover:opacity-0 px-3 group-hover:-translate-y-[70%] transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                            Get the Resources
                          </span>
                          <span className="absolute top-0 left-14 opacity-0 translate-y-[70%] text-center group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                            <OpenInNewIcon /> Open
                          </span>
                        </span>
                      </button>
                    </a>
                  </div>
                </div>
              </li>
              <li
                data-aos="fade-up"
                data-aso-delay="300"
                className="grid lg:grid-cols-2 grid-cols-1 py-10 border-t-[1px] border-[#fafaf6] border-opacity-40"
              id="abbadox-portal"
              >
                <div className="flex flex-col justify-between">
                  {" "}
                  <img
                    src={abbdox}
                    className="w-80 brightness-200"
                    alt="abbdox Logo"
                  />
                  <p className="text-[#d78558] sm:text-4xl text-[1.7rem] lg:mb-0 mb-4 font-black">
                    AbbaDox® Portal
                  </p>
                </div>
                <div>
                  <p className="font-robout xl:text-[1.35rem] md:text-xl sm:text-lg text-[16px] text-[#fafaf6] pb-2">
                    AbbaDox® is your patient portal and personal health network
                    that enables you to control and organize your healthcare
                    records, track your prevention and wellness activities and
                    communicate with your health providers. It’s secure and it’s
                    free.
                  </p>

                  <div className="flex sm:flex-row flex-col-reverse lg:flex-col-reverse xl:flex-row gap-3 md:items-center lg:items-start xl:items-center pt-2">
                    <a
                      href="http://www.abbadoxcareflow.com/"
                      target="_blank"
                      rel="noreferrer noopener"
                      className="group relative inline-flex h-14 mt-3  w-60 items-center rounded-full px-8 font-semibold  bg-transparent overflow-hidden"
                    >
                      <span className="absolute inset-0 rounded-full bg-[#d78558] transition-transform duration-[1800ms] ease-[cubic-bezier(0.19,1,0.22,1)] scale-100 group-hover:scale-100">
                        <span className="absolute left-1/2 top-[-60%] -translate-x-1/2 aspect-square w-[max(200%,10rem)]">
                          <span className="absolute inset-0 rounded-full bg-[#a374ff] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                          <span className="absolute inset-0 rounded-full bg-[#17f1d1] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-100 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                          <span className="absolute inset-0 rounded-full bg-[#d78558] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-200 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                        </span>
                      </span>
                      <span className="relative">
                        <span className="flex flex-row gap-2 justify-center items-center text-center ps-5 group-hover:opacity-0 group-hover:-translate-y-[70%] transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                          <OpenInNewIcon /> Login Here
                        </span>
                        <span className="absolute flex flex-row gap-2 top-0 left-5  opacity-0 translate-y-[70%] text-center group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                          <OpenInNewIcon /> Login Here
                        </span>
                      </span>
                    </a>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default ForClinics;
